import React, { createContext, useMemo, useCallback } from 'react';
import useLocalStorage from 'main/hooks/useLocalStorage';

const partnerConfig = {
  linkAlianza: {
    name: "linkAlianza",
    showName: "Link Alianza",
    primaryColor: "#FC4C03",
    buttonColor: "#FC4C03",
  },
  avista: {
    name: "avista",
    showName: "Avista",
    primaryColor: "#D70068",
    buttonColor: "#D70068",
  },
  default: {
    name: "avista",
    showName: "Avista",
    primaryColor: "#D70068",
    buttonColor: "#D70068",
  }
};

const initialState = {
  partner: partnerConfig.default,
  setPartner: () => {},
};

const PartnerContext = createContext(initialState);

export function PartnerProvider({ children }) {
  const [partner, setPartnerInStorage] = useLocalStorage('partner-config', partnerConfig.default);

  const setPartner = useCallback((partnerName) => {
    // Busca la configuración del partner. Si no existe, usa la de por defecto.
    const newPartnerConfig = partnerConfig[partnerName] || partnerConfig.default;
    setPartnerInStorage(newPartnerConfig);
  }, [setPartnerInStorage]);

  const value = useMemo(() => ({
    partner,
    setPartner,
  }), [partner, setPartner]);

  return (
    <PartnerContext.Provider value={value}>
      {children}
    </PartnerContext.Provider>
  );
}

export default PartnerContext;
